import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';

@Directive({
  selector: '[appTrimInput]'
})
export class TrimInputDirective {
  constructor(
    @Optional() private ngModel: NgModel,
    @Optional() private ngControl: NgControl
  ) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (value == null) return;

    const trimmed = value.replace(/\s+/g, ' ').trimStart();

    if (trimmed !== value) {
      if (this.ngModel) {
        this.ngModel.update.emit(trimmed);
      }

      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setValue(trimmed, { emitEvent: false });
      }
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const cleaned = input.value.trim();

    if (input.value !== cleaned) {
      input.value = cleaned;

      if (this.ngModel) {
        this.ngModel.update.emit(cleaned);
      } else if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setValue(cleaned, { emitEvent: false });
      }
    }
  }
}
